import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-approval",
  "use": "icon-approval-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-approval\"><circle stroke=\"#333\" stroke-width=\"1.5\" cx=\"10\" cy=\"10\" r=\"9.25\" /><path d=\"M9.28 14L5.23 9.865a.816.816 0 0 1 0-1.138.776.776 0 0 1 1.115 0l2.935 2.998 5.384-5.498a.776.776 0 0 1 1.105.009c.305.31.308.813.008 1.129L9.28 14z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol